import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import { pure, mapProps, compose, branch, renderComponent } from 'recompose'

import styles from './styles.scss'

const Collapse = props => {
  return (
    <IconButton
      onClick={props.onClick}
      icon='expand_less'
    />
  )
}

const Expand = props => {
  return (
    <IconButton
      onClick={props.onClick}
      icon='expand_more'
    />
  )
}

export default compose(
  mapProps(
    ({ toggleCollapse, collapse }) => ({
      onClick: toggleCollapse,
      collapse
    })
  ),
  branch(
    ({ collapse }) => collapse,
    renderComponent(Expand)
  ),
  pure
)(Collapse)
